import alAzhar5Img from "../images/clients/al-azhar-5.webp";
import bawasluImg from "../images/clients/bawaslu.webp";
// import garudaCyberIndonesiaImg from "../images/clients/garuda-cyber-indonesia.webp";
import jinggaImg from "../images/clients/jingga.webp";
import sunsetGlobalIndonesiaImg from "../images/clients/sunset-global-indonesia.webp";
import tirtaSiakImg from "../images/clients/tirta-siak.webp";
import uirImg from "../images/clients/uir.webp";
import umriImg from "../images/clients/umri.webp";
import unriImg from "../images/clients/unri.webp";

const clients = [
  {
    id: 1,
    name: "Taman Kanak-kanak Islam Al-Azhar 5",
    img: alAzhar5Img,
  },
  {
    id: 2,
    name: "Bawaslu - Panwaslu Kecamatan Marpoyan Damai",
    img: bawasluImg,
  },
  // {
  //   id: 3,
  //   name: "Garuda Cyber Indonesia",
  //   img: garudaCyberIndonesiaImg,
  // },
  {
    id: 4,
    name: "Jingga",
    img: jinggaImg,
  },
  {
    id: 5,
    name: "Sunset Global Indonesia",
    img: sunsetGlobalIndonesiaImg,
  },
  {
    id: 6,
    name: "Tirta Siak",
    img: tirtaSiakImg,
  },
  {
    id: 7,
    name: "Universitas Islam Riau",
    img: uirImg,
  },
  {
    id: 8,
    name: "Universitas Muhammadiyah Riau",
    img: umriImg,
  },
  {
    id: 9,
    name: "Universitas Riau",
    img: unriImg,
  },
];

export default clients;
